<script setup>
const leasing = useLeasingParams();
const props = defineProps({
  value: [Number, String],
  offerClient: String,
  isLiczak: {
    type: Boolean,
    value: false
  }
})

const vat = computed(() => {
  if(props.offerClient) {
    return props.offerClient === 'entrepreneur' ? 1 : 1.23;
  } else {
    return  leasing.refParams.value.client === 'entrepreneur' ? 1 : 1.23;
  }});
const liczakPrice = computed(() => props.value ? (parseFloat(props.value.toString().replace(/\s/g, '').replace(',', '.')) * vat.value).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "");
const price = computed(() => props.value ? priceFormat(parseValue(props.value.toString()) * vat.value) : "")
</script>

<template>
    <span v-if="!isLiczak">{{ price }}</span>
    <span v-else>{{ liczakPrice }}</span>
</template>
